import { xcss } from '@atlaskit/primitives';

export const containerStyles = xcss({
  borderRadius: 'border.radius.100',
});

export const hoverStyles = xcss({
  backgroundColor: 'elevation.surface.hovered',
});
